module.exports = __webpack_public_path__ + "static/img/h5-10.2b6d9e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-10.png
// module id = zZaD
// module chunks = 1